{
  "Quoter": {
    "QuoteError": "The quotation could not be obtained"
  }
}